// Shared link cell used by both the tiptap `ScorecardTableExtension` (offer
// composer) and the React `ScorecardHistoryTable` (HtmlRenderer hydration).
// Returns the literal '-' when no URL is present so consumers can drop it
// directly into a <td>.

const linkStyle: React.CSSProperties = { color: '#5C53C9' };

export const renderScorecardLinkCell = (url?: string | null) => {
  if (!url) return '-';
  return (
    <a href={url} target="_blank" rel="noopener noreferrer" style={linkStyle}>
      Link
    </a>
  );
};
